// formFieldInk.js — ISP-9999 (gordon-0915-form-block-ten-fixes, item 1).
//
// GORDON 2026-09-15 02:30 PT: "Form label/help text is dark-on-dark over image
// fills = illegible -> auto light/dark by measured contrast for labels,
// required markers, helper copy and the footer note (same rule as poll
// question / blocks auto-contrast law — reuse the existing utility)."
//
// Applies the SAME auto-contrast law utils/segmentEmptyStateInk.js already
// established for the "This segment is empty" placeholder text: keep the
// existing color wherever it already passes WCAG AA (so nothing moves on the
// overwhelmingly common light background) and only swap to the higher-
// contrast ink/white pick when it doesn't. An image wallpaper (currentBg===2)
// is not statically samplable — the same documented limitation every other
// auto-contrast call site in this codebase (segmentEmptyStateInk.js itself,
// GraphChart.jsx, Buttons.jsx…) accepts — so it falls back to the caller's
// existing default, unchanged, exactly like the precedent.
//
// Reused (not reinvented) from utils/contrast.js + utils/segmentEmptyStateInk.js:
// this file only wires those two together for the Form block's three text
// roles (label ink, required-marker red, helper/footer muted grey), each of
// which needs its OWN default to fall back to.
import { autoTextColor, effectiveBgHex, meetsContrastAA } from "../../../../utils/contrast";
import { resolveSegmentBackdrop } from "../../../../utils/segmentEmptyStateInk";

/**
 * Pick a legible color for a Form-block text role, given the segment settings
 * it renders over.
 *
 * @param {{currentBg?: number, segmentBgColor?: string, wallpaperOverlayColor?: string}} [segmentSettings]
 * @param {string} defaultInk the color this role paints today (label ink,
 *        required-marker red, helper/footer muted grey…)
 * @returns {string} `defaultInk` unless the segment's SAMPLABLE background
 *          fails AA against it, in which case the higher-contrast ink/white pick.
 */
export function formFieldInk(segmentSettings, defaultInk) {
  const hex = effectiveBgHex(resolveSegmentBackdrop(segmentSettings));
  if (!hex) return defaultInk; // unsamplable (image wallpaper, or no segment) -> unchanged
  if (meetsContrastAA(defaultInk, hex)) return defaultInk; // already legible -> unchanged
  return autoTextColor(hex, { fallback: defaultInk });
}

export default formFieldInk;
